import React, {Component} from 'react';
import bus from './bus';
import Ajax from './ajax';

class Register extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.onChargeChange = this.onChargeChange.bind(this);
    }

    onChargeChange() {
        let value = this.charge.value;
        this.chargeForm1.style.display = value == 1 ? 'flex' : 'none';
        this.chargeForm2.style.display = value == 2 ? 'flex' : 'none';
    }

    submit(event) {
        event.preventDefault();
        let value = this.charge.value;
        if (value == 1) {
            if (this.expired.value.length < 1) {
                alert('请选择到期时间');
                return;
            }
        } else if (value == 2) {
            if (this.remain.value.length < 1) {
                alert('请输入通知条数');
                return;
            }
        }
        let data = {name: this.name.value, charge: this.charge.value, expired: this.expired.value, remain: this.remain.value};
        Ajax.post('register', data, function (response) {
            if (response.result) {
                bus.emit('result', response);
            }
        });
    }

    render() {
        return (
            <form onSubmit={this.submit}>
                <div className="weui-cells weui-cells_form">
                    <div className="weui-cell">
                        <div className="weui-cell__hd"><label className="weui-label">项目名称</label></div>
                        <div className="weui-cell__bd">
                            <input id="name" ref={name => this.name = name} className="weui-input" type="text" required placeholder="请输入项目名称"/>
                        </div>
                    </div>
                    <div className="weui-cell weui-cell_select weui-cell_select-after">
                        <div className="weui-cell__hd">
                            <label htmlFor="charge" className="weui-label">计费模式</label>
                        </div>
                        <div className="weui-cell__bd">
                            <select className="weui-select" id="charge" ref={charge => this.charge = charge} onChange={this.onChargeChange}>
                                <option value="1" selected>计时</option>
                                <option value="2">计量</option>
                            </select>
                        </div>
                    </div>
                    <div className="weui-cell" ref={form => this.chargeForm1 = form}>
                        <div className="weui-cell__hd"><label htmlFor="expired" className="weui-label">到期时间</label></div>
                        <div className="weui-cell__bd">
                            <input id="expired" ref={expired => this.expired = expired} className="weui-input" type="date"/>
                        </div>
                    </div>
                    <div className="weui-cell" ref={form => this.chargeForm2 = form} style={{display: 'none'}}>
                        <div className="weui-cell__hd"><label htmlFor="remain" className="weui-label">通知条数</label></div>
                        <div className="weui-cell__bd">
                            <input id="remain" ref={remain => this.remain = remain} className="weui-input" type="number" pattern="[0-9]*" placeholder="请输入通知条数"/>
                        </div>
                        <div className="weui-cell__ft" style={{fontSize: '17px'}}>条</div>
                    </div>
                    <div className="weui-btn-area">
                        <input className="weui-btn weui-btn_primary" type="submit" value="提交"/>
                    </div>
                </div>
            </form>
        );
    }
}

export default Register;



// WEBPACK FOOTER //
// ./src/register.js